import { pushWithRegion } from 'actions/NavigationActions'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import { searchVerticalItemsByKey } from 'constants/search'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import { useGlobalMerchandiseSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalMerchandiseSearch'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'
import qs from 'qs'
import { useCallback, useMemo } from 'react'
import SearchV2MerchandiseTabContent from '../Components/Mobile/TabContents/SearchV2MerchandiseTabContent'

function useGlobalSearchVerticalTabMerchandise(): App.GlobalSearchVerticalTabV2 {
  const dispatch = useAppDispatch()
  const queryParams = useQueryParams()
  const [
    searchDispatch,
    state,
  ] = useGlobalMerchandiseSearchContext(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const onSearch = useCallback(() => {
    const query = qs.stringify({
      search: state.searchItem?.value,
    })

    dispatch(pushWithRegion('/search/shop', query))
  }, [dispatch, state.searchItem?.value])

  return useMemo((): App.GlobalSearchVerticalTabV2 => ({
    label: searchVerticalItemsByKey.get('merchandise')?.label ?? 'Shop',
    key: 'merchandise',
    context: { dispatch: searchDispatch, state },
    onSearch,
    ContentComponent: SearchV2MerchandiseTabContent,
    Icon: LineShopIcon,
  }), [searchDispatch, state, onSearch])
}

export default useGlobalSearchVerticalTabMerchandise
